// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1931":"fbb8914b0881a9a9","2443":"fbb8914b0881a9a9","3185":"216dd0defdf4d9ff"}[chunkId] + ".css";
};